export const environment = {
  production: false,
  imagePrefix: "assets/images/",

  apiUrl: "https://1lo63i3c2i.execute-api.us-east-1.amazonaws.com/dev/", // dev

  //  apiUrl: "https://actapi.dcafecms.com/", //preprod

  // apiUrl: "https://vuuzle.dcafecms.com/api/v1/",                   //prod
  // apiUrl: 'https://vuzzle.dev.dctinc.net/api/v1/',                 //dev
  //apiUrl: "https://2cs12gc8pa.execute-api.us-east-1.amazonaws.com/vuuzle-dev/", //node dev
  //apiUrl: "https://1lo63i3c2i.execute-api.us-east-1.amazonaws.com/dev/", //node dev
  // apiUrl: 'https://vuuzleapi.dcafecms.com/', // node prod
  apiUrlDollywood: "https://dollywoodplay.admin.demo.dctinc.net/api/v1/",
  apiUrlCarousal: "https://hungamakids.admin.stage.dctinc.net/api/v1/",
  // googleAuthKey: '247746380086-fbrglglfl6lvcn575u82248khpbef1j2.apps.googleusercontent.com', //prod
  googleAuthKey:
    "695989545489-ehsia82b9l31723f82dfilfm9rtfbo41.apps.googleusercontent.com", //dev
  // facebookAuthId: "2473374139418803", //prod
  facebookAuthId: "2239905339471156", // dev
  //stripeKey: "pk_test_Kxjj6yhJEOF6Nj2BHDKtUc4l00T2rCAVpJ",
  stripeKey:
    "pk_test_51H2iXNGaWWk9jbaBacXWDP99d3NA7KZ6sZpeS6jhPl9n8glDsffaBnx0LiTRttJbg14ZqnXrIHCnvEJMS1NPlrNl00Mlz45HFM",
  firebaseConfig: {
    apiKey: "AIzaSyATQa_5jZtfGPNxXXjpnUkk2vxjEC3E8a0",
    authDomain: "virtualactorg.firebaseapp.com",
    databaseURL: "https://virtualactorg.firebaseio.com",
    projectId: "virtualactorg",
    storageBucket: "virtualactorg.appspot.com",
    messagingSenderId: "1006135013429",
    appId: "1:1006135013429:web:4c1baeeba4067e0506417c",
    measurementId: "G-3V3NKZLPDR"
  },
};
